/* TinyTots universal mini-cart outfit engine, unpublished QA theme.
   Only Shopify-published catalog entries; variant stock/colour/size fetched live before showing.
   Never maps clothing ages to EU shoe sizes; cart is the pricing and inventory authority.
*/
(function(){
'use strict';
if(window.__ttUniversalOutfitsV1)return;window.__ttUniversalOutfitsV1=true;
var D='#t4s-mini_cart',CACHE=new Map(),STATE={signature:'',gender:null,request:0,busy:false,syncing:false,selectedClothingSize:null,sizeAnchor:null},TIMER=0;
var DISCOUNTS={"imported-todler-jogger":20,"imported-girls-sandal-fancy":20,"imported-girls-sandal-kiddy":20,"imported-boys-large-sandal":20,"led-joggers-imported":20,"bow-doted-shoes":20,"double-strap-boys":20,"sketchers-small-group":20,"little-booties":20,"imported-boys-medium-sandal":20,"imported-bunny-fleets":20,"girls-matt-finish-pumps":20,"boys-paded-sandals-large-group":20,"boys-led-sandals-medium-group":20,"imported-light-weight-joggers":20,"china-fleets":20,"colorful-kiddies-sandals":20,"imported-bear-close-grip-sandal":20,"zip-boots-led":20,"girls-glitter-pumps":20,"infant-sandals":20,"imported-3d-printed-shoes":20,"imported-long-style-boots":20,"girls-snow-white-sandles":20,"yong-high-heel-joggers":20,"kiddy-sneakers":20,"light-weight-velcaro-shoes":20,"fancy-sandals-china":20,"kids-sketcher-shoes":20,"kids-sketcher-shoes-a":20,"boys-paded-sandals-large":20,"boys-white-sole-sandals":20,"boys-rotary-buckle-skates":20,"boys-creep-sole-shoes":20,"zig-zag-sandals":20,"girls-pumps-medium":20,"girls-sandals-with-led-lights":20,"toddler-colorful-sandles":20,"kids-sketcher-shoes-b":20,"boys-loafers":20,"kids-sketcher-shoes-1":20,"long-joggers":20,"colorful-close-sandals":20,"long-style-sandals":20,"ltstest-02":20,"s25chpjst-c":20,"ltstest-04":20,"s26chstrt-a":20,"s26chstrt-b":20,"s26thrmp-a":20,"s26thrmp-b":20,"w25catrh-a":20,"w25catrh-b":20,"w25catrh-c":20,"w25catrh-d":20,"w25chnswt-a":20,"w25chnswt-b":20,"w25chnswt-c":20,"w25chnswt-d":20,"fw26jhk":20,"fw26swk":20,"w25wlnrm-a":20,"w25wlnrm-b":20,"fw26vyb-a":20,"fw26vyb-b":20,"fw26ltmx-a":20,"fw26ltmx-b":20,"w26btspst":20,"w26furmp":20,"w26rbtrm":20,"w24lgfrm":20,"w26rwcdst":20,"w26fltrh":20,"w26ombhd":20,"fw26nbpmp":20,"fw26crpmp":20,"w26pocdst":20,"w26tmckst-a":20,"w26tmckst-c":20,"w26tmtop":20,"w26btbwst":20,"w26btbbst":20,"w26btwpck-a":20,"w26btwpck-b":20,"w26ttgdnm":20,"w26ttgdnm-b":20,"w26ttbdnm-a":20,"w26ttbdnm-b":20,"w26ttbdnm-c":20,"w26anmst":20,"junior-pajama-suit":30,"chico-pajama-suit":30,"s25chpjst-b":30,"w25pprmp":30,"w25prtwr-a":30,"w25prtwr-b":30,"s25jrpjst-b":30,"s25jrpjst-a":30,"w25tommy":30,"w25pepswt":30,"w25sncswt":30,"w25zylss-a":30,"w25zylss-b":30,"w25totswt-a":30,"w25totswt-b":30,"w25bbrmp-a":30,"w25bbrmp-b":30,"w25bktset":30,"w25rbswtr-a":30,"w25rbswtr-b":30,"w25rbswtr-c":30,"w25rbswtr-d":30,"w25dgtop":30,"w25pntst":30,"w25tmckst-a":30,"w25tmckst-b":30,"w25tmckst-c":30,"w25tmckst-d":30,"w25tbtst-a":30,"w25tbtst-b":30,"w25pndst-a":30,"w25pndst-b":30,"w25lhtgt":30,"w24ttgfc-a":30,"w24tthfc-a":30,"w24tthfc-b":30,"w23csht":30,"w26bdyst":30,"w26cmftrh":30,"w26frkjkt":30,"w24lftrh":30,"w21mstrkh":30,"w24lhtgt":30,"w22gshtrh":30,"w24wmst":30,"w23srtrh":30,"w24inner":30,"w24dmtop":30,"w21mntlh":30,"w24bkfml":30,"w24ntfltr":30,"w22flrhd":30,"w21mhnkng":30,"w25mxsuit":30,"w25tmdst":30,"w24rplst":30,"w24gltst":30,"w24mpcah":30,"w25yfkhd":30,"w25hwkjkt":30,"w25lgcoat":30,"casual-shirts-superheroes":40,"china-casual-shirt-small":40,"china-casual-shirt-small-1":40,"mng-large-casual-shirts":40,"china-casual-shirt-small-2":40,"china-baggy-trousers":40,"ethnic-wear-medium":40,"w25ttjmp":40,"w24ttgfc":40,"s25ttsjmp":40,"s25ttljmp":40,"w26chntrh-a":40,"w26chntrh-b":40,"w25nornst":40,"w23anmtr":40,"w24pepitr-a":40,"w24pepitr-b":40,"w24zyswt-a":40,"w24zyswt-b":40,"w25bunny":40,"w24kibswt":40,"w20anmhd":40,"w24mneck":40,"w23jmpst":40,"w24csttpc":40,"w25frtst":40,"w25dkjpk":40,"w23exmhd":40,"w23pkboo":40,"w24mngst":40,"w25dnmjkt":40,"w24catrh-a":40,"w24catrh-b":40,"w25lftpk":40,"w25lptrh-a":40,"w25lptrh-b":40,"w23cooltr":40,"w23pntlt":40};
function root(){return(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/'}
function $d(){return document.querySelector(D)}
function norm(x){return String(x||'').toLowerCase().replace(/[\s–—_]+/g,'').trim()}
function text(x){return String(x||'').toLowerCase()}
function money(v){return 'Rs. '+(Number(v||0)/100).toLocaleString('en-PK',{maximumFractionDigits:0})}
function safeImg(raw){if(typeof raw==='string')return raw.startsWith('//')?'https:'+raw:raw;return raw&&typeof raw.src==='string'?safeImg(raw.src):''}
async function cart(){var r=await fetch(root()+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});if(!r.ok)throw Error('Could not read cart');return r.json()}
function fingerprint(c){return JSON.stringify((c.items||[]).map(function(x){return [x.key,x.variant_id||x.id,x.quantity,x.handle]}))}
function category(p){
 var type=text(p.pt||p.product_type),name=text(p.t||p.product_title||p.title),classes=','+text(p.c||'')+',';
 var gender='unisex';
 if(/\bunisex\b/.test(name)||type.includes('unisex'))gender='unisex';
 else if(type.includes('girl'))gender='girls';
 else if(type.includes('boy'))gender='boys';
 else if(/\bgirl/.test(name)&&!/\bboy/.test(name))gender='girls';
 else if(/\bboy/.test(name)&&!/\bgirl/.test(name))gender='boys';
 else if(classes.includes(',newborn-boys,')&&!classes.includes(',newborn-girls,'))gender='boys';
 else if(classes.includes(',newborn-girls,')&&!classes.includes(',newborn-boys,'))gender='girls';
 else if(type.includes('footwear')||type==='footwear'){
  if(classes.includes(',boys-shoes,')&&!classes.includes(',girls-shoes,'))gender='boys';
  if(classes.includes(',girls-shoes,')&&!classes.includes(',boys-shoes,'))gender='girls';
 }
 var kind='top';
 if(type.includes('footwear')||/shoes|sneakers|sandals|pumps|boots|loafers|fleets|skates|first.walkers/.test(name))kind='shoe';
 else if(/romper|bodysuit|jumpsuit|gift set|2.piece|two.piece|co.ord|track.?suit|outfit set|frock|dress|pinafore|winter suit|suit\b/.test(name)
   ||/girls-jumpsuits|girls-2-piece|boys-track-suits|new-born-romper|new-born-suit|2-piece/.test(classes))kind='complete';
 else if(/boys-lowers-or-bottoms|lowers-or-bottoms|girls-trousers|boys-trousers|boys-shorts/.test(classes)
   ||/trouser|jogger pants|sweatpants|denim|jeans|legging|pants|shorts/.test(name))kind='bottom';
 else if(/w24catrh|w25catrh/.test(p.h||''))kind='bottom';
 var season=/winter|hoodie|fleece|sweatshirt|sweater|wool|knit|padded|coat|warm|thermal|high.neck/.test(name)?'winter':
 /sandal|shorts|summer|sleeveless|floral dress/.test(name)?'summer':'neutral';
 if(kind==='shoe'&&/sandal|open.toe/.test(name))season='summer';
 return {kind:kind,gender:gender,season:season};
}
function dedupCatalog(widget){
 var el=widget.querySelector('[data-tt-look-catalog]'),raw;
 try{raw=JSON.parse(el.textContent)}catch(e){return[]}
 var map=new Map();
 (raw.products||[]).forEach(function(p){if(p.h&&!map.has(p.h)){p.c=p.c||'';p.role=category(p);map.set(p.h,p)}});
 return Array.from(map.values());
}
function apparelAgeBand(size){
 var str=String(size||'').trim().replace(/\s/g,'');
 var month=str.match(/^(\d+)-(\d+)M$/i);
 if(month){
  var lo=Number(month[1]),hi=Number(month[2]);
  if(hi<=12)return'newborn';
  if(lo>=12&&hi<=24)return'baby';
  return null;
 }
 if(/^\d+(?:-\d+)?Y$/i.test(str))return'child';
 return null;
}
function infantShoe(p){
 var handle=text(p?.h||p?.handle),name=text(p?.t||p?.title),classes=','+text(p?.c||'')+',';
 return classes.includes(',new-born-shoes,')||
  /^fw26prwk-[a-c]$/.test(handle)||
  (/first walker|infant winter crib/.test(name)&&/shoe|walker|crib/.test(name));
}
function newbornCatalogOnly(p){
 var cls=','+text(p.c||'')+',',type=text(p.pt||p.product_type),title=text(p.t||p.title);
 return /,(?:new-born|new-borns|new-born-[^,]+|newborn-[^,]+|suits-new-born),/.test(cls)||
  /new.?born/.test(type)||/\bnew\s?born\b/.test(title);
}
function productAgeBand(p,kind,selectedSize){
 if(kind==='shoe')return infantShoe(p)?'newborn':null; /* ordinary EU sizes do not establish clothing age */
 return apparelAgeBand(selectedSize);
}
function cartKind(line,meta){return category(meta||{h:line.handle,t:line.product_title,pt:line.product_type||''})}
function lineSize(line,role){
 if(role.kind==='shoe')return null;
 var opts=line.variant_options||[];
 var x=opts.length>1?opts[1]:null;
 if(!x&&line.variant_title){var parts=line.variant_title.split('/');x=parts.length>1?parts[parts.length-1].trim():parts[0].trim()}
 return x&&/[0-9]/.test(x)?String(x).trim():null;
}
function anchorContext(c,catalog){
 var lookup=new Map(catalog.map(function(p){return[p.h,p]}));
 var rows=(c.items||[]).map(function(line){
  var meta=lookup.get(line.handle),role=cartKind(line,meta),size=lineSize(line,role);
  return{line:line,meta:meta,role:role,size:size,ageBand:productAgeBand(meta||{h:line.handle,t:line.product_title},role.kind,size)};
 });
 var ref=rows.find(function(r){return r.role.kind!=='shoe'&&r.meta})||rows.find(function(r){return r.meta})||null;
 if(!ref)return null;
 var gender=ref.role.gender;
 if(gender==='unisex'){var garment=rows.find(function(r){return r.role.gender!=='unisex'&&r.role.kind!=='shoe'});if(garment)gender=garment.role.gender}
 var size=ref.size||rows.find(function(r){return r.size&&r.role.kind!=='shoe'&&r.role.gender===gender})?.size||null;
 var ageBand=ref.ageBand||apparelAgeBand(size);
 if(ref.role.kind==='shoe'&&!infantShoe(ref.meta)){
  if(STATE.sizeAnchor!==ref.line.key){STATE.selectedClothingSize=null;STATE.sizeAnchor=ref.line.key}
  var chosenBand=apparelAgeBand(STATE.selectedClothingSize);
  size=(chosenBand==='baby'||chosenBand==='child')?STATE.selectedClothingSize:null;
  ageBand=apparelAgeBand(size)||'pending';
 }
 if(!ageBand)return null; /* unknown clothing size: withhold guessing */
 var present={top:false,bottom:false,shoe:false,complete:false};
 rows.forEach(function(r){
  if(gender!=='unisex'&&r.role.gender!=='unisex'&&r.role.gender!==gender)return;
  if(r.role.kind==='shoe'&&r.line.key===ref.line.key){present.shoe=true;return}
  if(r.ageBand!==ageBand)return;
  if(r.role.kind!=='shoe'&&size&&r.size!==size)return;
  present[r.role.kind]=true;
  if(r.role.kind==='complete'){present.top=true;present.bottom=true}
 });
 return{ref:ref,gender:gender,size:size,ageBand:ageBand,rows:rows,present:present,season:ref.role.season,kind:ref.role.kind};
}
function targets(ctx){
 if(ctx.kind==='complete')return ctx.present.shoe?[]:['shoe'];
 if(ctx.kind==='shoe'&&ctx.ageBand==='newborn')return ['complete','top','bottom'].filter(function(k){return !ctx.present[k]});
 var wants=['top','bottom','shoe'];
 return wants.filter(function(k){return !ctx.present[k]});
}
function eligible(p,ctx,role,gender){
 if(ctx.rows.some(function(r){return r.line.handle===p.h}))return false;
 if(ctx.ref.line.handle==='w23pntlt'&&(p.h==='w25rbtrh-b'||p.h==='w26fltrh'))return false;
 var c=p.role;if(c.kind!==role)return false;
 if(role==='shoe'){
  /* First-walker/crib footwear is newborn-only. Never offer ordinary kids footwear to newborns. */
  if(ctx.ageBand==='newborn'&&!infantShoe(p))return false;
  if(ctx.ageBand!=='newborn'&&infantShoe(p))return false;
  /* Infant/toddler months beyond newborn need verified footwear fit data, not an EU-to-age guess. */
  if(ctx.ageBand==='baby')return false;
 }else{
  /* Respect the newborn catalog boundary as well as garment size. */
  if(ctx.ageBand==='newborn'&&!newbornCatalogOnly(p))return false;
  if(ctx.ageBand!=='newborn'&&newbornCatalogOnly(p))return false;
  if(ctx.ageBand==='newborn'&&!(p.sizes||[]).some(function(s){return apparelAgeBand(s)==='newborn'}))return false;
  if(ctx.ageBand==='baby'&&!(p.sizes||[]).some(function(s){return apparelAgeBand(s)==='baby'}))return false;
  if(ctx.ageBand==='child'&&!(p.sizes||[]).some(function(s){return apparelAgeBand(s)==='child'}))return false;
 }
 if(c.gender!=='unisex'&&gender!==c.gender)return false;
 if(gender==='unisex'&&role!=='shoe')return false;
 if(ctx.season==='winter'&&(c.season==='summer'||/sandal|slides|slipper|shorts/.test(text(p.t))))return false;
 if(ctx.season==='summer'&&c.season==='winter')return false;
 if(role==='shoe'&&ctx.ageBand==='newborn'&&!infantShoe(p))return false;
 if(ctx.size&&role!=='shoe'&&!p.sizes.some(function(s){return norm(s)===norm(ctx.size)}))return false;
 return true;
}
function candidateScore(p,ctx,role){
 var name=text(p.t),score=0;
 if(ctx.season===p.role.season)score+=6;
 if(p.role.season==='neutral')score+=4;
 if(role==='bottom'&&/denim|jogger|trouser|pants/.test(name))score+=5;
 if(role==='top'&&/sweatshirt|hoodie|sweater|shirt|top/.test(name))score+=5;
 if(role==='shoe'&&/sneaker|shoes|boot/.test(name))score+=5;
 if(role==='shoe'&&/sandal/.test(name))score-=3;
 if(p.role.gender===ctx.gender)score+=4;
 if(p.role.gender==='unisex')score+=1;
 if(p.h==='w25rbtrh-b')score-=5;
 return score;
}
async function liveProduct(handle){
 var cached=CACHE.get(handle);
 if(cached&&Date.now()-cached.time<30000)return cached.data;
 var response=await fetch(root()+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
 if(!response.ok)throw Error('Product not available');
 var obj=await response.json();
 if(!obj||!Array.isArray(obj.variants))throw Error('Invalid product data');
 CACHE.set(handle,{time:Date.now(),data:obj});return obj;
}
function colorScore(col,source,gender){
 var c=norm(col),anchor=norm(source);
 if(c===anchor&&c)return 35;
 var neutrals=['white','offwhite','beige','cream','black','grey','charcoalgrey','darkblue','navy','blue','brown','lightbrown','skin','lightblue'];
 if(neutrals.includes(c))return 25-neutrals.indexOf(c);
 if(gender==='girls'&&['pink','lightpink','blush','purple','peach','skyblue'].includes(c))return 12;
 if(gender==='boys'&&['green','darkgreen','olivegreen','red'].includes(c))return 8;
 return -50;
}
function pickVariants(item,ctx,role){
 var vs=(item.variants||[]).filter(function(v){return !!v.available});
 if(!vs.length)return null;
 var colors=Array.from(new Set(vs.map(function(v){return norm(v.option1)})));
 var source=ctx.ref.line.variant_options&&ctx.ref.line.variant_options[0]||'';
 colors.sort(function(a,b){return colorScore(b,source,ctx.gender)-colorScore(a,source,ctx.gender)});
 var bestColor=colors.find(function(c){return colorScore(c,source,ctx.gender)>=0});
 if(!bestColor)return null;
 vs=vs.filter(function(v){return norm(v.option1)===bestColor&&v.option2!=null});
 if(!vs.length)return null;
 if(role==='shoe'){
  vs=vs.filter(function(v){
   var n=Number(v.option2);
   return Number.isFinite(n)&&(ctx.ageBand==='newborn'?(n>=11&&n<=13):(ctx.ageBand==='child'?n>=16:false));
  });
 }else{
  vs=vs.filter(function(v){return apparelAgeBand(v.option2)===ctx.ageBand});
 }
 if(!vs.length)return null;
 if(ctx.size&&role!=='shoe'){
  var match=vs.find(function(v){return norm(v.option2)===norm(ctx.size)});
  if(!match)return null;vs=[match];
 }
 return vs;
}
async function findMatching(meta,ctx,role,gender){
 var ordered=meta.filter(function(p){return eligible(p,ctx,role,gender)})
  .sort(function(a,b){return candidateScore(b,ctx,role)-candidateScore(a,ctx,role)||a.h.localeCompare(b.h)})
  .slice(0,24);
 var picked=[];
 for(var at=0;at<ordered.length&&picked.length<5;at+=6){
  var batch=ordered.slice(at,at+6);
  var vals=await Promise.all(batch.map(async function(p){
   try{
    var actual=await liveProduct(p.h),variants=pickVariants(actual,ctx,role);
    if(!variants)return null;
    return{meta:p,item:actual,variants:variants,col:variants[0].option1};
   }catch(e){return null}
  }));
  vals.forEach(function(x){if(x&&picked.length<5)picked.push(x)});
 }
 return picked;
}
function element(tag,cls,content){
 var e=document.createElement(tag);if(cls)e.className=cls;if(content!=null)e.textContent=content;return e;
}
function priceUI(p,v){
 var price=Number(v.price||0),discount=Number(DISCOUNTS[p.meta.h]||0);
 var box=element('span','tt-mini-look__price');
 if(discount>0){
  var del=element('del','',money(price));
  var ins=element('ins','',money(Math.round(price*(100-discount)/100)));
  box.append(del,ins);
 }else box.append(element('ins','',money(price)));
 return box;
}
function optionCard(p,ctx,role){
 var v=p.variants[0],card=element('article','tt-mini-look__option'+(role==='shoe'?' tt-mini-look__option--shoe':(!ctx.size?' tt-mini-look__option--size':'')));
 var link=element('a','tt-mini-look__photo');link.href='/products/'+encodeURIComponent(p.meta.h);
 link.setAttribute('aria-label','View '+p.item.title);
 var img=element('img','');img.loading='lazy';img.alt=p.item.title+' '+p.col;
 img.width=108;img.height=96;img.src=safeImg(v.featured_image)||safeImg(p.item.featured_image)||safeImg((p.item.images||[])[0]);
 link.append(img);card.append(link);
 var info=element('div','tt-mini-look__cardinfo'),title=element('a','');
 title.href=link.href;title.append(element('strong','',p.item.title+' · '+p.col));info.append(title);
 if(ctx.size&&role!=='shoe')info.append(element('span','tt-mini-look__matched-size','Size '+v.option2));
 info.append(priceUI(p,v));card.append(info);
 var select=null;
 if(role==='shoe'||!ctx.size){
  select=element('select','tt-mini-look__shoe-size');
  select.setAttribute('aria-label',role==='shoe'?'Choose EU shoe size for '+p.item.title:'Choose clothing size for '+p.item.title);
  select.append(element('option','',''+(role==='shoe'?'EU size':'Clothing size')));
  select.options[0].value='';
  var all=p.variants.slice().sort(function(a,b){return String(a.option2).localeCompare(String(b.option2),undefined,{numeric:true})});
  all.forEach(function(x){var opt=element('option','',role==='shoe'?'EU '+x.option2:x.option2);opt.value=String(x.id);select.append(opt)});
  select.addEventListener('change',function(){
   var vv=p.variants.find(function(x){return String(x.id)===select.value});
   if(vv){info.replaceChild(priceUI(p,vv),info.querySelector('.tt-mini-look__price'));img.src=safeImg(vv.featured_image)||img.src}
  });
  card.append(select);
 }
 var btn=element('button','tt-mini-look__select','Add to cart');btn.type='button';
 btn.setAttribute('aria-label','Add '+p.item.title+' to cart');
 btn.addEventListener('click',function(){
  var id=select?Number(select.value):Number(v.id);
  if(!id){showError('Choose the '+(role==='shoe'?'EU shoe':'clothing')+' size first.');if(select)select.focus();return}
  addVariant(id,btn);
 });card.append(btn);return card;
}
function showError(message){var drawer=$d(),el=drawer&&drawer.querySelector('[data-tt-look-error]');if(el)el.textContent=message||''}
function sectionWidget(html){
 if(!html)return null;
 var doc=new DOMParser().parseFromString(html,'text/html');
 return doc.querySelector('[data-tt-global-look]');
}
async function getSection(){
 var preview=new URLSearchParams(location.search).get('preview_theme_id');
 var suffix=preview?'&preview_theme_id='+encodeURIComponent(preview):'';
 for(var u of [location.pathname+'?section_id=mini_cart'+suffix,root()+'cart?section_id=mini_cart'+suffix]){
  try{
   var r=await fetch(u,{credentials:'same-origin',cache:'no-store'});
   if(r.ok){var textHtml=await r.text();var found=sectionWidget(textHtml);if(found)return{html:textHtml,widget:found}}
  }catch(e){}
 }
 return null;
}
async function ensureWidget(){
 var d=$d();if(!d)return null;
 var w=d.querySelector('[data-tt-global-look]');if(w)return w;
 var response=await getSection();
 if(!response)return null;
 w=response.widget.cloneNode(true);
 var note=d.querySelector('[data-cart-tools]');
 var list=d.querySelector('[data-cart-items]');
 if(note&&note.parentNode)note.parentNode.insertBefore(w,note);
 else if(list)list.insertAdjacentElement('afterend',w);
 return w;
}
async function updateDrawer(){
 var data=await getSection();if(!data)return false;
 var d=$d();if(!d)return false;
 var dom=new DOMParser().parseFromString(data.html,'text/html');
 for(var sel of ['[data-cart-items]','[data-cart-prices]','[data-cart-discounts]','[data-cart-calc-shipping]']){
  var old=d.querySelector(sel),fresh=dom.querySelector(sel);
  if(old&&fresh)old.replaceWith(fresh.cloneNode(true));
 }
 var oldWidget=d.querySelector('[data-tt-global-look]');
 if(oldWidget)oldWidget.remove();
 if(data.widget){
  var w=data.widget.cloneNode(true),note=d.querySelector('[data-cart-tools]'),list=d.querySelector('[data-cart-items]');
  if(note&&note.parentNode)note.parentNode.insertBefore(w,note);else if(list)list.insertAdjacentElement('afterend',w);
 }
 return true;
}
async function addVariant(id,button){
 if(STATE.busy)return;STATE.busy=true;button.disabled=true;button.textContent='Adding…';showError('');
 var accepted=false;
 try{
  var r=await fetch(root()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})});
  var result=await r.json();if(!r.ok)throw Error(result.description||result.message||'Item could not be added');
  accepted=true;
  document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
  if(!await updateDrawer())throw Error('Drawer refresh delayed');
  STATE.signature='';STATE.busy=false;queueSync(80);return;
 }catch(e){
  if(accepted){try{sessionStorage.setItem('tt-universal-reopen','1')}catch(ignore){}location.reload();return}
  button.disabled=false;button.textContent='Add to cart';STATE.busy=false;showError(e.message||'Item could not be added');
 }
}
function listSection(title,items,ctx,role){
 var block=element('div','tt-global-look__group');
 var heading=element('div','tt-mini-look__heading');heading.append(element('strong','',title),element('span','',role==='shoe'?'Choose an EU size':ctx.size?'Size '+ctx.size:'Choose clothing size'));
 block.append(heading);
 var rail=element('div','tt-mini-look__rail');rail.setAttribute('role','group');rail.setAttribute('aria-label',title);
 items.forEach(function(x){rail.append(optionCard(x,ctx,role))});block.append(rail);
 var browse=element('a','tt-mini-look__browse','Browse more '+title.toLowerCase()+' ↗');
 browse.href=role==='shoe'?(ctx.ageBand==='newborn'?'/collections/new-born-shoes':'/collections/footwear-1'):
 role==='complete'?'/collections/new-born':
 role==='bottom'?(ctx.gender==='boys'?'/collections/boys-lowers-or-bottoms':'/collections/lowers-or-bottoms'):
 (ctx.ageBand==='newborn'?'/collections/new-born':ctx.gender==='boys'?'/collections/boys':'/collections/girls');
 block.append(browse);return block;
}
async function paint(widget,c,signature){
 var meta=dedupCatalog(widget),ctx=anchorContext(c,meta);var request=++STATE.request;
 if(!ctx){widget.hidden=true;return}
 if(ctx.ageBand==='pending'){
  widget.hidden=false;
  widget.querySelector('[data-tt-look-subtitle]').textContent='Choose clothing size to find an outfit';
  var target=widget.querySelector('[data-tt-look-content]');target.replaceChildren();
  var label=element('label','tt-global-look__size-prompt','What clothing size does your child wear?');
  var chooser=element('select','tt-global-look__size-chooser');chooser.setAttribute('aria-label','Choose clothing size');
  var initial=element('option','','Select clothing size');initial.value='';chooser.append(initial);
  var choices=Array.from(new Set(meta.filter(function(p){return p.role.kind!=='shoe'}).flatMap(function(p){return p.sizes||[]})))
   .filter(function(v){return apparelAgeBand(v)==='baby'||apparelAgeBand(v)==='child'})
   .sort(function(a,b){return a.localeCompare(b,undefined,{numeric:true})});
  choices.forEach(function(v){var op=element('option','',v);op.value=v;chooser.append(op)});
  chooser.onchange=function(){STATE.selectedClothingSize=this.value;STATE.sizeAnchor=ctx.ref.line.key;STATE.signature='';queueSync(0)};
  label.append(chooser);target.append(label);
  return;
 }
 if(ctx.gender!=='unisex')STATE.gender=ctx.gender;
 if(ctx.gender==='unisex'&&STATE.gender!=='girls'&&STATE.gender!=='boys')STATE.gender=null;
 var gender=ctx.gender==='unisex'?STATE.gender:ctx.gender;
 var genderPanel=widget.querySelector('[data-tt-look-gender]');
 genderPanel.hidden=ctx.gender!=='unisex';
 genderPanel.querySelectorAll('[data-tt-gender-choice]').forEach(function(btn){
  btn.setAttribute('aria-pressed',String(STATE.gender===btn.getAttribute('data-tt-gender-choice')));
  btn.onclick=function(){STATE.gender=btn.getAttribute('data-tt-gender-choice');STATE.signature='';queueSync(0)};
 });
 var desired=targets(ctx);
 var area=widget.querySelector('[data-tt-look-content]');area.replaceChildren();
 if(!desired.length){widget.hidden=true;return}
 widget.hidden=false;
 widget.querySelector('[data-tt-look-subtitle]').textContent=ctx.kind==='shoe'?'Complete an outfit starting with shoes':ctx.kind==='bottom'?'Add a matching top and footwear':ctx.kind==='complete'?'Add footwear to finish the outfit':'Add matching bottoms and footwear';
 if(genderPanel.hidden===false&&!gender){area.append(element('p','tt-global-look__hint','Choose Boys or Girls above to see matching articles.'));return}
 area.append(element('p','tt-global-look__hint','Finding matching sizes in stock…'));
 var groups=[];
 for(var role of desired){
  if(request!==STATE.request)return;
  var results=await findMatching(meta,ctx,role,gender);
  groups.push({role:role,results:results});
 }
 if(request!==STATE.request)return;
 try{var latest=await cart();if(fingerprint(latest)!==signature){STATE.signature='';queueSync(100);return}}catch(ignore){STATE.signature='';queueSync(400);return}
 var d=$d();if(!d||!d.contains(widget))return;
 area.replaceChildren();
 groups.forEach(function(g){
  if(g.results.length)area.append(listSection(g.role==='shoe'?'Footwear':g.role==='complete'?'Newborn outfits':g.role==='bottom'?'Matching bottoms':'Matching tops',g.results,ctx,g.role));
 });
 if(!area.children.length){area.append(element('p','tt-global-look__hint','No suitable sizes currently available. Browse our collections for more options.'))}
}
async function sync(){
 if(STATE.syncing||STATE.busy)return;STATE.syncing=true;
 try{
  var c=await cart(),sig=fingerprint(c);
  if(!c.items||!c.items.length){STATE.signature=sig;var empty=$d()?.querySelector('[data-tt-global-look]');if(empty)empty.hidden=true;return}
  var w=await ensureWidget();if(!w){STATE.signature='';return}
  if(sig===STATE.signature)return;
  STATE.signature=sig;await paint(w,c,sig);
 }catch(e){STATE.signature=''}
 finally{STATE.syncing=false}
}
function queueSync(delay){
 if(TIMER)clearTimeout(TIMER);
 TIMER=setTimeout(function(){TIMER=0;sync()},delay==null?300:delay);
}
function init(){
 queueSync(350);
 var drawer=$d();
 var observer=new MutationObserver(function(entries){
  if(STATE.busy)return;
  for(var e of entries){
   if(e.type!=='childList')continue;
   if(e.target.closest&&e.target.closest('[data-tt-global-look]'))continue;
   if(e.target.closest&&(e.target.closest('[data-cart-items]')||e.target.id==='t4s-mini_cart')){
    queueSync(320);return;
   }
   var nodes=[...e.addedNodes,...e.removedNodes];
   if(nodes.some(function(n){return n.nodeType===1&&(n.matches&&n.matches('[data-cart-items],#t4s-mini_cart')||n.querySelector&&n.querySelector('[data-cart-items],#t4s-mini_cart'))})){queueSync(320);return}
  }
 });
 observer.observe(document.body,{subtree:true,childList:true});
 document.addEventListener('click',function(e){
  if(e.target.closest&&e.target.closest('#t4s-mini_cart [data-cart-remove],#t4s-mini_cart [data-cart-quantity]')){
   queueSync(700);setTimeout(function(){queueSync(150)},1450);
  }
 },true);
 ['cart:updated','cart:change','cart:changed','cart:refresh:opend','shopify:section:load'].forEach(function(name){document.addEventListener(name,function(){queueSync(350)})});
 setInterval(function(){
  if(document.hidden||STATE.busy)return;
  var d=$d();if(!d)return;
  if(d.getAttribute('aria-hidden')==='true'||d.classList.contains('t4s-dn'))return;
  queueSync(120);
 },3500);
 try{if(sessionStorage.getItem('tt-universal-reopen')==='1'){sessionStorage.removeItem('tt-universal-reopen');document.dispatchEvent(new CustomEvent('cart:refresh:opend'))}}catch(e){}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();